// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 获取element-ui框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// import axios from './../node_modules/axios/dist/axios.min.js';
// Vue.prototype.$http=axios.create({
// 	headers:{'Content-Type':'application/json;charset=utf-8'},withCredentials:true,
// });
// import axios from './api/axios.js';
import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios = axios;

// 设置全局变量
import global_ from './Base.vue'
Vue.prototype.GLOBAL = global_;
axios.defaults.baseURL=global_.BASE_URL;

// import Mock from 'mockjs'
// Vue.prototype.$ajax = axios;


import echarts from 'echarts' //引入echarts
Vue.prototype.$echarts = echarts //引入组件

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js